import { render, staticRenderFns } from "./InkObservation.vue?vue&type=template&id=48a3c9d7&scoped=true&"
import script from "./InkObservation.vue?vue&type=script&lang=js&"
export * from "./InkObservation.vue?vue&type=script&lang=js&"
import style0 from "./InkObservation.vue?vue&type=style&index=0&id=48a3c9d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3c9d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBadge,VBtn,VCard,VCol,VContainer,VIcon,VRow,VSpeedDial})
